import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Accordion} from "react-bootstrap";
import { GetPagePermissionFn } from "../../common/authority";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
import http from "../../common/http-common";
import CssClass from "../../Styles/common.module.css";
import classes from "../../Styles/permission.module.css";
import PUserInfoTable from "../../components/AccessManagement/Permissions/PUserInfoTable";
import PRoleInfoTable from "../../components/AccessManagement/Permissions/PRoleInfoTable";
import PNewTicketInfoTable from "../../components/AccessManagement/Permissions/PNewTicketInfoTable";
import PTicketInfoTable from "../../components/AccessManagement/Permissions/PTicketInfoTable";
import PTicketDetailInfoTable from "../../components/AccessManagement/Permissions/PTicketDetailInfoTable";
import PPermissionInfoTable from "../../components/AccessManagement/Permissions/PPermissionInfoTable";
import PPolicyInfoTable from "../../components/AccessManagement/Permissions/PPolicyInfoTable";
import POrganizationInfoTable from "../../components/AccessManagement/Permissions/POrganizationInfoTable";
import PSystemInfoTable from "../../components/AccessManagement/Permissions/PSystemInfoTable";
import PTicketCatInfoTable from "../../components/AccessManagement/Permissions/PTicketCatInfoTable";
import PTicketPriorityInfoTable from "../../components/AccessManagement/Permissions/PTicketPriorityInfoTable";
import PTicketStatusInfoTable from "../../components/AccessManagement/Permissions/PTicketStatusInfoTable";
import PTicketHistoryInfoTable from "../../components/AccessManagement/Permissions/PTicketHistoryInfoTable";
import PTicketSummaryInfoTable from "../../components/AccessManagement/Permissions/PTicketSummaryInfoTable";
import PAgentKPIInfoTable from "../../components/AccessManagement/Permissions/PAgentKPIInfoTable";
import PSystemInfoInfoTable from "../../components/AccessManagement/Permissions/PSystemInfoInfoTable";
import PServerEnvInfoTable from "../../components/AccessManagement/Permissions/PServerEnvInfoTable";
import PServerConnTypeInfoTable from "../../components/AccessManagement/Permissions/PServerConnTypeInfoTable";


const PAGE_NAME = "Permission.js_";
const MODULE_ID = "WEB_USR_003";

const Permissions = (props) => {
  document.title = common.c_TITLE + " - Permission Maintenance";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [roleOptions, setRoleOptions] = useState([]);
  const [selectedRole, setSelectedRole] = useState([]);
  const [allData, setAllData] = useState({
    'Users': [], 
    'Roles': [], 
    'Permissions': [],
    'Policy': [],
    'Organization': [],
    'System': [],
    'Ticket Category': [],
    'Ticket Priority': [],
    'Ticket Status': [],
    'New Ticket': [], 
    'View Ticket': [],
    'Ticket List': [],
    'Ticket List History': [],
    'Ticket Summary': [],
    'Agent KPI': [],
    'System Info': [],
    'Server Environment': [],
    'Server Connection Type': [],
  });
  // const [allData, setAllData] = useState({
  //   CAT_MASTER_DATA: [],
  //   CAT_TICKET: [],
  // });

  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");

  const [actionPermission, setActionPermission] = useState({
    READ: "Y",
    WRITE: "Y",
  });

  // Expand all accordions
  const [activeKeys, setActiveKeys] = useState([]);

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionPermission(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionPermission({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    let functionName = "";
    const roleDetail = [];

    try {
      functionName = "useEffect Get All Roles";
      onLoadingHandler(true, "Getting User Role List, please wait...");

      http
        .get("api/permission/GetAllRole?_user=" + userId, {
          timeout: 10000000,
        })
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              roleDetail.push({
                key: data.ROLE_ID,
                value: data.ROLE_ID,
                label: data.ROLE_NAME,
              });
            });
          }
          setRoleOptions(roleDetail);
        })
        .catch((err) => {
          toast.error("Error on getting user role list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          setLoading(false);
          setLoadingText("Loading...");
        });
    } catch (err) {
      toast.error("Error on getting user role list. Please try again.");
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }, [userId]);

  //#region Event Handlers
  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };
  //#endregion

  const selectRoleHandler = (val) => {
    if (val !== selectedRole) {
      let functionName = "";
      try {
        functionName = selectRoleHandler.name;
        setSelectedRole(val);

        // 👇 Expand all sections automatically
        setActiveKeys([
          "Users", "Roles", "Permissions", "Policy", "Organization",
          "System", "Ticket Category", "Ticket Priority", "Ticket Status",
          "New Ticket", "View Ticket", "Ticket List", "Ticket List History",
          "Ticket Summary", "Agent KPI", "System Info", "Server Environment", "Server Connection Type"
        ]);
        
        GetFeaturePermissionByID(val.key, "Users")
        .then(() => GetFeaturePermissionByID(val.key, "Roles"))
        .then(() => GetFeaturePermissionByID(val.key, "Permissions"))
        .then(() => GetFeaturePermissionByID(val.key, "Policy"))
        .then(() => GetFeaturePermissionByID(val.key, "Permissions"))
        .then(() => GetFeaturePermissionByID(val.key, "Organization"))
        .then(() => GetFeaturePermissionByID(val.key, "System"))
        .then(() => GetFeaturePermissionByID(val.key, "Ticket Category"))
        .then(() => GetFeaturePermissionByID(val.key, "Ticket Priority"))
        .then(() => GetFeaturePermissionByID(val.key, "Ticket Status"))
        .then(() => GetFeaturePermissionByID(val.key, "Ticket List"))
        .then(() => GetFeaturePermissionByID(val.key, "View Ticket"))
        .then(() => GetFeaturePermissionByID(val.key, "New Ticket"))
        .then(() => GetFeaturePermissionByID(val.key, "Ticket List History"))
        .then(() => GetFeaturePermissionByID(val.key, "Ticket Summary"))
        .then(() => GetFeaturePermissionByID(val.key, "Agent KPI"))
        .then(() => GetFeaturePermissionByID(val.key, "System Info"))
        .then(() => GetFeaturePermissionByID(val.key, "Server Environment"))
        .then(() => GetFeaturePermissionByID(val.key, "Server Connection Type"));
        // GetTicketButtonPermission(val.key);
        // GetFeaturePermission(val.key, "CAT_MASTER_DATA").then(() =>
        //   GetFeaturePermission(val.key, "CAT_TICKET")
        // );
        // GetTicketPermission(val.key);
      } catch (err) {
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  };

  // async function GetFeaturePermission(roleId, moduleCat) {
  //   let functionName2 = "";
  //   const listItems = [];
  //   try {
  //     functionName2 = PAGE_NAME + GetFeaturePermission.name;
  //     onLoadingHandler(
  //       true,
  //       `Getting ${moduleCat} feature permission list, please wait...`
  //     );

  //     await http
  //       .get(
  //         `api/permission/GetFeaturePermission?_user=${userId}&_roleId=${roleId}&_moduleCat=${moduleCat}`,
  //         { timeout: 10000000 }
  //       )
  //       .then((response) => {
  //         if (response.data.length > 0) {
  //           response.data.forEach((data, counter) => {
  //             var details = [];
  //             data.PERMISSION_DETAILS.forEach((detail, i) => {
  //               details.push({
  //                 key: detail.MODULE_FEATURE_ID,
  //                 rowNo: i,
  //                 MODULE_FEATURE_ID: detail.MODULE_FEATURE_ID,
  //                 FEATURE_TYPE: detail.FEATURE_TYPE,
  //                 ROLE_AUTHORITY_ID: detail.ROLE_AUTHORITY_ID,
  //                 AUTHORIZED: detail.AUTHORIZED,
  //               });
  //             });
  //             listItems.push({
  //               key: data.MODULE_NAME,
  //               rowNo: counter,
  //               MODULE_NAME: data.MODULE_NAME,
  //               PERMISSION_DETAILS: details,
  //             });
  //           });
  //         }
  //         setAllData((prevState) => ({
  //           ...prevState,
  //           [moduleCat]: listItems,
  //         }));
  //       })
  //       .catch((err) => {
  //         toast.error(
  //           `Error on getting ${moduleCat} feature permission list. Please try again.`
  //         );
  //         common.c_LogWebError(PAGE_NAME, functionName2, err);
  //       })
  //       .finally(() => {
  //         onLoadingHandler(false, "Loading...");
  //       });
  //   } catch (err) {
  //     onLoadingHandler(false, "Loading...");
  //     toast.error(
  //       `Failed to get ${moduleCat} feature permission list. Please try again.`
  //     );
  //     common.c_LogWebError(PAGE_NAME, functionName2, err);
  //   }
  // }

  async function GetFeaturePermissionByID (roleId, moduleName) {
    let functionName2 = "";
    const listItems = [];
    try {
      functionName2 = PAGE_NAME + GetFeaturePermissionByID.name;
      onLoadingHandler(
        true,
        `Getting ${moduleName} feature permission list, please wait...`
      );

      await http
        .get(
          `api/permission/GetFeaturePermissionByID?_user=${userId}&_roleId=${roleId}&_moduleName=${moduleName}`,
          { timeout: 10000000 }
        )
        .then((response) => {
          if (response.data.length > 0) {
            response.data.forEach((data, counter) => {
              var details = [];
              data.PERMISSION_DETAILS.forEach((detail, i) => {
                details.push({
                  key: detail.MODULE_FEATURE_ID,
                  rowNo: i,
                  MODULE_FEATURE_ID: detail.MODULE_FEATURE_ID,
                  FEATURE_TYPE: detail.FEATURE_TYPE,        
                  ROLE_AUTHORITY_ID: detail.ROLE_AUTHORITY_ID,
                  AUTHORIZED: detail.AUTHORIZED,
                });
              });
              listItems.push({
                // key: data.MODULE_NAME,
                key: data.FEATURE_DESC,
                rowNo: counter,
                // MODULE_NAME: data.MODULE_NAME,
                PERMISSION_DETAILS: details,
                FEATURE_DESC: data.FEATURE_DESC,
              });
            });
          }
          setAllData((prevState) => ({
            ...prevState,
            [moduleName]: listItems,
          }));
        })
        .catch((err) => {
          toast.error(
            `Error on getting ${moduleName} feature permission list. Please try again.`
          );
          common.c_LogWebError(PAGE_NAME, functionName2, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error(
        `Failed to get ${moduleName} feature permission list. Please try again.`
      );
      common.c_LogWebError(PAGE_NAME, functionName2, err);
    }
  }

  function ChangeFeaturePermission(moduleFeatureId, val) {
    let functionName = "";
    try {
      functionName = PAGE_NAME + ChangeFeaturePermission.name;
      onLoadingHandler(true, "Changing authority, please wait...");
      const data = {
        ROLE_ID: selectedRole.key,
        ROLE_NAME: selectedRole.label,
        MODULE_FEATURE_ID: moduleFeatureId,
        AUTHORIZED: val === true ? "Y" : "N",
        UPDATE_ID: userId,
      };
      http
        .post("api/permission/ChangeFeaturePermission", data, {
          timeout: 10000,
        })
        .then((response) => {
          toast.success(
            `Permission is successfully ${
              val === true ? "inserted" : "removed"
            }.`
          );
        })
        .catch((err) => {
          toast.error(
            `Failed to ${
              val === true ? "insert" : "remove"
            } authority. Please try again.`
          );
          common.c_LogWebError(PAGE_NAME, functionName, err);
        })
        .finally(() => {
          onLoadingHandler(false, "Loading...");
        });
    } catch (err) {
      onLoadingHandler(false, "Loading...");
      toast.error(
        `Failed to ${
          val === true ? "insert" : "remove"
        } authority. Please try again.`
      );
      common.c_LogWebError(PAGE_NAME, functionName, err);
    }
  }

  return (
    <>
      <Comp.Header>Permission Management</Comp.Header>
      
      <div style={{ margin: "10px" }}>
        <div
          style={{
            padding: "0 10px",
          }}
        >
          <table className="table table-bordered table-hover">
            <tbody>
              <tr>
                <td style={{ verticalAlign: "middle", width: "40%" }}>
                  Role*:
                </td>
                <td style={{ verticalAlign: "middle", width: "10%" }}>:</td>
                <td style={{ verticalAlign: "middle", width: "50%" }}>
                  <Comp.Select
                    options={roleOptions}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    allowSelectAll={false}
                    value={selectedRole}
                    onChange={selectRoleHandler}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between"}}
      >
        <Accordion activeKey={activeKeys.includes("Users") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}> 
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                  color: "black",
                }}
              >
                Users
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PUserInfoTable
                  // data={
                  //   Object.keys(allData).length !== 0 &&
                  //   allData.CAT_MASTER_DATA.length !== 0 &&
                  //   allData.CAT_MASTER_DATA[0].PERMISSION_DETAILS.length !== 0
                  //     ? allData.CAT_MASTER_DATA
                  //     : []
                  // }
                  data={Object.keys(allData.length !== 0) && allData["Users"].length !== 0 && allData["Users"][0].length !== 0
                          ? allData["Users"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("Roles") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}> 
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Roles
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PRoleInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Roles"].length !== 0 && allData["Roles"][0].length !== 0
                          ? allData["Roles"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("Permissions") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Permissions
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PPermissionInfoTable 
                  data={Object.keys(allData.length !== 0) && allData["Permissions"].length !== 0 && allData["Permissions"][0].length !== 0
                          ? allData["Permissions"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("Policy") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Policy
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PPolicyInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Policy"].length !== 0 && allData["Policy"][0].length !== 0
                          ? allData["Policy"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("Organization") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Organization
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <POrganizationInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Organization"].length !== 0 && allData["Organization"][0].length !== 0
                          ? allData["Organization"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("System") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                System
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PSystemInfoTable
                  data={Object.keys(allData.length !== 0) && allData["System"].length !== 0 && allData["System"][0].length !== 0
                          ? allData["System"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("Ticket Category") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Ticket Category
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PTicketCatInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Ticket Category"].length !== 0 && allData["Ticket Category"][0].length !== 0
                          ? allData["Ticket Category"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("Ticket Priority") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0">
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Ticket Priority
              </h5>
            </Accordion.Header>
            <Accordion.Body>
              <div>
                <PTicketPriorityInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Ticket Priority"].length !== 0 && allData["Ticket Priority"][0].length !== 0
                          ? allData["Ticket Priority"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("Ticket Status") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Ticket Status
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PTicketStatusInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Ticket Status"].length !== 0 && allData["Ticket Status"][0].length !== 0
                          ? allData["Ticket Status"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("Ticket List") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Ticket List
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PTicketInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Ticket List"].length !== 0 && allData["Ticket List"][0].length !== 0
                    ? allData["Ticket List"]
                    : []
                  }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("View Ticket") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                View Ticket
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PTicketDetailInfoTable
                  data={Object.keys(allData.length !== 0) && allData["View Ticket"].length !== 0 && allData["View Ticket"][0].length !== 0
                    ? allData["View Ticket"]
                    : []
                  }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />                          
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("New Ticket") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                New Ticket
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PNewTicketInfoTable
                  data={Object.keys(allData.length !== 0) && allData["New Ticket"].length !== 0 && allData["New Ticket"][0].length !== 0
                        ? allData["New Ticket"]
                        : []
                      }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("Ticket Summary") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Ticket Summary
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PTicketSummaryInfoTable 
                  data={Object.keys(allData.length !== 0) && allData["Ticket Summary"].length !== 0 && allData["Ticket Summary"][0].length !== 0
                          ? allData["Ticket Summary"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("Agent KPI") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Agent KPI
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PAgentKPIInfoTable 
                  data={Object.keys(allData.length !== 0) && allData["Agent KPI"].length !== 0 && allData["Agent KPI"][0].length !== 0
                          ? allData["Agent KPI"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("Server Connection Type") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Server Connection Type
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PServerConnTypeInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Server Connection Type"].length !== 0 && allData["Server Connection Type"][0].length !== 0
                          ? allData["Server Connection Type"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        <Accordion activeKey={activeKeys.includes("Server Environment") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                Server Environment
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PServerEnvInfoTable
                  data={Object.keys(allData.length !== 0) && allData["Server Environment"].length !== 0 && allData["Server Environment"][0].length !== 0
                          ? allData["Server Environment"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
      <div
        className={`${CssClass.card} ${CssClass.tableCard}`}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <Accordion activeKey={activeKeys.includes("System Info") ? "0" : ""} alwaysOpen className={classes.accordion} style={{ width: "48%" }}>
          <Accordion.Item eventKey="0" className={classes.transparent}>
            <Accordion.Header className={classes.accordionheader}>
              <h5
                style={{
                  // fontWeight: "bold",
                  // // backgroundColor: "lightblue",
                  marginBottom: 0,
                  width: "100%",
                }}
              >
                System Info
              </h5>
            </Accordion.Header>
            <Accordion.Body className={classes.transparent}>
              <div>
                <PSystemInfoInfoTable
                  data={Object.keys(allData.length !== 0) && allData["System Info"].length !== 0 && allData["System Info"][0].length !== 0
                          ? allData["System Info"]
                          : []
                        }
                  ChangeFeaturePermission={ChangeFeaturePermission}
                  actionPermission={actionPermission}
                />
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>

      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default Permissions;
